
import {
  toLakh,
  sumThis,
  numberWithCommas,
  toCurrency,
  sumOf,
  countOf,
  sumAndCountOf,
  showSum,
  showCount,
  showSumAndCount,
  percentChange,
  showBlank,
  changeClassTo,
  mobileNumber,
  panCardNumber,
  validEmail,
  adharNumber,
  allDirectQueries
} from "../../../commonFunctions";
import { controls } from "../../../controls";

const rp720 = {
  label: "Lein Reports",
  pageLabel: "Lein Reports",
  starting: true,
  url: "rp720",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isRequired: true, defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2", label: "Product Type" }),
    ...controls.ProductType({ tab: "filter", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),

    ...controls.displayText({ tab: "filter", label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "product_code_display", name: "product_code_display" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "As On Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "as_on_date", width: "col-sm-2", default: "sessiondate" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2", label: "Account Number From " }),
    ...controls.text({ tab: "filter", width: "col-sm-2", placeHolder: "Account Number From", name: "account_number_from" }),
    ...controls.text({ tab: "filter", width: "col-sm-2", placeHolder: "Account Number To", name: "account_number_to" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.magicDateLabel({ tab: "filter", label: "Opening Date From To", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "open_date_from", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "open_date_to", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2", label: "Sanction Amount From " }),
    ...controls.numberOnly({ tab: "filter", width: "col-sm-2", placeHolder: "Sanction Amount From", name: "sanction_amount_from" }),
    ...controls.numberOnly({ tab: "filter", width: "col-sm-2", placeHolder: "Sanction Amount To", name: "sanction_amount_to" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2", label: "NPA Status" }),
    ...controls.NpaStatus({ tab: "filter", width: "col-sm-2" }),

  ],
  form: [

  ],
  history: {
    perPage: 10,
    reportHeader: "Deposit Accounts",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30,
      },


      {
        Header: "Deposits",
        columns: [
          {
            Header: "GL Sub",
            accessor: "gl_sub_head",
          },
          {
            Header: "Account Number",
            accessor: "account_number",
          },
          {
            Header: "Description",
            accessor: "description",
            // width: 300,
            // rwidth: "*"
          },
          {
            Header: "Amount",
            accessor: "amount",
            type: "currency"
          },
          {
            Header: "Lien Amount",
            accessor: "lien_amount",
            type: "currency"
          },
          {
            Header: "Interest Rate",
            accessor: "interest_rate",
            type: "currency",

          }
        ]
      },
      {
        Header: "Loans",
        columns: [
          {
            Header: "GL Sub",
            accessor: "gl_sub_head",
          },
          {
            Header: "Account Number",
            accessor: "account_number",
          },
          {
            Header: "Description",
            accessor: "description",
            // width: 300,
            // rwidth: "*"
          },
          {
            Header: "Amount",
            accessor: "amount",
            type: "currency"
          },
          {
            Header: "Opening Date",
            accessor: "open_date",
          },
          {
            Header: "Expiry Date",
            accessor: "expiry_date",
          },
          {
            Header: "Interest Rate",
            accessor: "interest_rate",
            type: "currency",

          }
        ]
      },
    ]
  }

}
export default rp720;